import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const SUBSCRIPTION_PAUSE_DOMAIN = "subscription-pause";
export const SUBSCRIPTION_PAUSE_DETAIL_ENDPOINT = "detail";
export const SUBSCRIPTION_PAUSE_CREATE_ENDPOINT = "create";
export const SUBSCRIPTION_PAUSE_UPDATE_ENDPOINT = "update";
export const SUBSCRIPTION_PAUSE_CANCEL_ENDPOINT = "cancel";

// reserved = 시작일이 미래(예약됨) / active = 오늘이 [startDate, endDate] 구간 내(일시정지 중)
export type SubscriptionPauseStatus = "reserved" | "active";

export interface SubscriptionPauseReservation {
  startDate: string; // "YYYY-MM-DD" (KST, 양끝 포함)
  endDate: string; // "YYYY-MM-DD" (KST, 양끝 포함)
  status: SubscriptionPauseStatus;
}

export interface SubscriptionPauseType {
  isAvailable: boolean; // false → 결제 페이지에서 일시정지 섹션 전체 숨김 (자격 규칙은 BE 소유)
  totalDays: number; // 총 일시정지 가능 일수
  usedDays: number; // 누적 사용 일수 (진행 중 active + 예약 reserved 포함)
  totalCount: number; // 총 일시정지 가능 횟수
  usedCount: number; // 누적 사용 횟수 (진행 중 + 예약 포함)
  reservation: SubscriptionPauseReservation | null; // 현재 예약/진행 1건, 없으면 null
}

export interface SubscriptionPauseRequest {
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
}

export const subscriptionPauseApi = {
  get: () =>
    axiosInstance.get<CustomResponseFormat<SubscriptionPauseType>>(
      `${SUBSCRIPTION_PAUSE_DOMAIN}/${SUBSCRIPTION_PAUSE_DETAIL_ENDPOINT}`
    ),
  create: (body: SubscriptionPauseRequest) =>
    axiosInstance.post<CustomResponseFormat<SubscriptionPauseType>>(
      `${SUBSCRIPTION_PAUSE_DOMAIN}/${SUBSCRIPTION_PAUSE_CREATE_ENDPOINT}`,
      body
    ),
  update: (body: SubscriptionPauseRequest) =>
    axiosInstance.post<CustomResponseFormat<SubscriptionPauseType>>(
      `${SUBSCRIPTION_PAUSE_DOMAIN}/${SUBSCRIPTION_PAUSE_UPDATE_ENDPOINT}`,
      body
    ),
  cancel: () =>
    axiosInstance.get<CustomResponseFormat<SubscriptionPauseType>>(
      `${SUBSCRIPTION_PAUSE_DOMAIN}/${SUBSCRIPTION_PAUSE_CANCEL_ENDPOINT}`
    ),
};
